// extracted by css-extract-rspack-plugin
export default {"required":"NjSVuf"};